<style>
select.optionShow {
  display: inline;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #9e9e9e;
  border-radius: 0;
  outline: none;
  font-size: 16px;
  margin: 0 0 8px 0;
  padding: 0;
}
.new-discount .v-text-field > .v-input__control > .v-input__slot:after,
.new-discount .v-text-field > .v-input__control > .v-input__slot:before {
  bottom: 9px !important;
}
</style>

<template lang="pug">
form(@submit.prevent='submit')
  .row
    p.col.s12.title.medium Create New Discount
  .row.new-discount
    .col.s12.m6.input-field
      input#discount(type='text', v-model='discount', required)
      label.active(for='discount') Discount Name
    .col.s12.m6.input-field
      input#discountAmount(
        type='number',
        min='0',
        v-model='discountAmount',
        required
      )
      label.active(for='discountAmount') Discount Amount
    .col.s12.m6.input-field
      select#discountType.optionShow(
        name='discountType',
        v-model='discountType'
      )
        option(value='fix') Fix
        option(value='percent') Percent
      label.active(for='discountType') Discount Type
    .col.s12.m6.input-field
      input#details(type='text', v-model='details', required)
      label.active(for='details') Details
    .col.s12.m6.input-field
      input#fromDate(
        type='text',
        v-model='fromDate',
        ref='daterangeFrom',
        required
      )
      label.active(for='fromDate') From
    .col.s12.m6.input-field
      input#toDate(type='text', ref='daterangeTo', required)
      label.active(for='toDate') To
  .row
    .col.s12.right-align
      button.btn Add
</template>
<script>
// import format from 'date-fns/format'
import moment from 'moment'
export default {
  props: ['onNewSuccess', 'onNewFailed'],
  data () {
    return {
      discountType: null,
      discountAmount: null,
      discount: null,
      details: null,
      fromDate: null,
      toDate: null
    }
  },
  mounted () {
    this.$M.Datepicker.init(this.$refs.daterangeFrom, {
      autoClose: true,
      onSelect: this.fromDateSelected,
      format: 'yyyy-mm-dd',
      minDate: new Date()
    })
    this.$M.Datepicker.init(this.$refs.daterangeTo, {
      onSelect: this.toDateSelected,
      autoClose: true,
      format: 'yyyy-mm-dd',
      minDate: this.fromDate
    })
  },
  computed: {},
  methods: {
    submit () {
      this.$store
        .dispatch('auth/getAccessToken')
        .then((accessToken) => {
          this.$http
            .post(
              `${this.$config.API_URL}/suppliers/discount/new`,
              {
                type: this.discountType,
                name: this.discount,
                description: this.details,
                amount: this.discountAmount,
                start: this.fromDate,
                end: this.toDate
              },
              {
                headers: {
                  authorization: `Bearer ${accessToken}`
                }
              }
            )
            .then((result) => {
              this.onNewSuccess(result.data)
            })
        })
        .catch((err) => {
          this.onNewFailed(err)
        })
    },
    fromDateSelected (val) {
      this.fromDate = moment(String(val)).format('YYYY-MM-DD')
      this.$M.Datepicker.init(this.$refs.daterangeTo, {
        onSelect: this.toDateSelected,
        autoClose: true,
        format: 'yyyy-mm-dd',
        minDate: val
      })
    },
    toDateSelected (val) {
      this.toDate = moment(String(val)).format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal-discount-new.vue